import { businessEntitiesMock } from '@mock/mockData/masterData';

export const USER = {
  name: "test user",
  email: "test-user@yopmail.com",
  registered_mobile: "8208000243",
  mid: 7210652,
  uuid: "12eb-a418-e73b8026-83ad-0a10338c65fa",
  product: "PayUBiz",
  display_name: "test user",
  business_origin: "PayUBiz",
  business_name: "test user",
  integration_type: "Tools",
  source_type: "Organic",
  mobile: "8208000243",
  dashboard_preference: "one_dashboard",
  acl_role_name: "MerchantAdminUserRole",
  merchant_uuid: "12eb-a418-e73b8026-83ad-0a10338c65fa"
}

export const TOKEN = {
  access_token: "148e2140112aa1c65e8d7cc982fbcd3bf46b2ab23a75c016e3d46e049d9c2aa2",
  token_type: "Bearer",
  expires_in: 86400,
  refresh_token: "347e3588b0e2a0102a30677b4624e9e4e03ae5d17a447d6a2eb761daf9850605",
  scope: "send_verification_otp verify_verification_otp read_dashboard_payumoney hub_session send_verification_link manage_addendum read_transactions read_settlements manage_refunds user_profile update_user_profile manage_notifications manage_checkouts manage_webhooks manage_credentials manage_payment_products create_invoice_payumoney update_invoice_payumoney read_invoice_payumoney create_vpas create_payout_transactions read_invoice_items create_invoice_items delete_invoice_items update_invoice_items create_subscription_plans read_invoice_details manage_roles manage_employees manage_thirdparty_access maker checker manage_approval_flow update_profile_restricted view_transaction_summary view_treasury_summary download_transaction_reports read_tdr download_settlement_reports read_refunds process_refunds download_refund_reports manage_chargebacks read_payment_links create_payment_links update_payment_links delete_payment_links read_buttons create_buttons update_buttons delete_buttons read_payment_handles create_payment_handles update_payment_handles delete_payment_handles read_invoices manage_payment_notifications manage_treasury_notifications create_invoices update_invoices delete_invoices create_dmt_transactions read_account_request_nb create_account_request_nb read_account_details_nb read_transaction_nb add_transaction_meta_data_nb download_transaction_nb read_summary_nb read_account_nmp read_sales_list_nmp read_sales_summary_nmp read_sales_detail_nmp read_settlement_list_nmp read_settlement_sumary_nmp read_settlement_details_nmp read_dispute_list_nmp read_dispute_summary_nmp read_dispute_details_nmp update_dispute_status_nmp register_account_nmp",
  created_at: 1626680313,
  user_uuid: "11eb-e84e-5fd827a4-ab01-02f413145cce",
  tokenLifeTime: "2021-07-20T07:38:00.659Z"
}

export const ACCOUNT = {
  account_id: null,
  account_uuid: "11eb-a418-e73b8026-89ad-0a10338c65fa",
  account_statuses: [],
}

export const BUSINESS_ENTITY = (entityName) => businessEntitiesMock.business_entities.find(
  entity => entity.name === entityName
);

export const PAN = {
  STATUS: {
    VERIFIED: 'Success',
    PENDING: 'Pending',
  },
  DETAILS: {
    EMPTY: {
      pancard_name: null,
      pancard_number: null,
    },
    FILLED: {
      pancard_name: 'PAYU PAYMENTS PVT',
      pancard_number: 'AAJCS9091D',
      business_entity_id: BUSINESS_ENTITY('Private Limited').id,
    },
    PVT: {
      pancard_name: 'PAYU PAYMENTS PVT',
      pancard_number: 'AAJCS9091D',
      business_entity_id: BUSINESS_ENTITY('Private Limited').id,
    },
    INDIVIDUAL: {
      pancard_name: 'Robin Scherbatsky',
      pancard_number: 'CETPB4507C',
      business_entity_id: BUSINESS_ENTITY('Individual').id,
    },
    NGO: {
      pancard_name: 'Robin Scherbatsky',
      pancard_number: 'CETPB4507C',
      business_entity_id: BUSINESS_ENTITY('NGO').id,
    },
  }
}


export const BANK = {
  STATUS: {
    VERIFIED: 'Success',
    PENDING: 'Pending',
  }
}

export const SIGNING_AUTHORITY = {
  FILLED: {
    signatory_contact_details: [{
      account_uuid: '2492-d574-87eea675-d429-8aa13787ff1f',
      name: 'PANKAJ PRAKASH HEDA',
      cin_number: 'U74999PN2019PTC186018',
      pancard_number: 'AAJCS9191D',
      email: 'test-bommu-494@yopmail.com',
    }]
  }
}